module.exports = __webpack_public_path__ + "static/scale-model-of-gresham-oregon-e41e1c21c5d6f2dada859d532a15b046.png";